import React from 'react';

/**
 * A component's design reference, from Storybook's `parameters.design`
 * (storybook-addon-designs: `{ type: 'figma', url }`, an array of those, or a
 * bare URL). The first link with a URL wins. Returns { url, label } or null.
 */
export function designLink(design) {
  const first = [design].flat().find((d) => (typeof d === 'string' ? d : d?.url));
  const url = typeof first === 'string' ? first : first?.url;
  if (!url || !/^https?:\/\//.test(url)) return null;
  const label = first?.name ?? (first?.type === 'figma' || /figma\.com\//.test(url) ? 'Figma' : 'Design');
  return { url, label };
}

const ARROW = 'M7 17L17 7M7 7h10v10';

/** The link as an edl pill beside a title (docs page and story view). */
export function DesignPill({ link, className = '' }) {
  if (!link) return null;
  const arrow = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={ARROW} />
    </svg>
  );
  return (
    <a className={`edl-pill edl-pill--small edl-pill--ghost ${className}`} href={link.url} target="_blank" rel="noreferrer" title={`Open in ${link.label}`}>
      {link.label}
      <span className="edl-pill__disc">
        {arrow}
        {arrow}
      </span>
    </a>
  );
}
